<template>
  <main>
    <section-hero :bgImg="bgImg" :subtitle="subtitle"></section-hero>
    <section-article
      :article="article"
      v-if="article.title"
      isTopSection="true"
      id="scrollToOnLoad">
      <div class="d-flex">
        <button class="btn my-4 mr-4 btn-primary btn-sm" v-scroll-to="'#game'">Game</button>
        <button
          class="btn my-4 btn-primary btn-sm"
          v-scroll-to="'#tips'"
          @click="isExpanded = true">
          Tips
        </button>
      </div>
    </section-article>
    <div class="section--building-blocks" v-show="windowWidth > 767">
      <b-container>
        <section id="tips" class="info__box">
          <img class="mr-3" src="@/assets/ico-finger.png" alt="">
          <div>
            <h2>{{ $t("buildingBlocks.game") }}</h2>
            <p class="text--small">
              {{ $t("buildingBlocks.gameContent") }}
            </p>
            <img @click="isExpanded = !isExpanded"
              :class="{ 'info__arrow--rotate' : isExpanded}"
              src="@/assets/ico_scroll-down-dark.svg" class="info__arrow" alt="">
          </div>
        </section>
        <transition name="slide">
          <div v-if="isExpanded">
            <game-heading ></game-heading>
            <game-table :blocks="blocks"></game-table>
          </div>
        </transition>
        <section class="info__box mt-5 mb-4">
          <img class="mr-3" src="@/assets/ico-finger.png" alt="">
          <div>
            <h2>{{ $t("buildingBlocks.buildingBlocks") }}</h2>
            <p class="text--small">
              {{ $t("buildingBlocks.buildingBlocksContent") }}
            </p>
          </div>
        </section>
        <game-board id="game" :blocks="blocks" :isEditable="isEditable">
          <section class="info__box" slot>
            <img class="mr-3" src="@/assets/ico-finger.png" alt="">
            <div>
              <h2>{{ $t("buildingBlocks.wellSetup") }}</h2>
              <p class="text--small">
                {{ $t("buildingBlocks.wellSetupContent") }}
              </p>
            </div>
          </section>
        </game-board>
        <div class="info__box mt-5">
          <router-link :to="{ path: `/report_my_results` }" tag="button"
            class="btn btn-primary report" v-scroll-to="'#scrollToOnLoad'">
            {{ $t("prevResults.check") }}
          </router-link>
        </div>
      </b-container>
    </div>
    <div v-show="windowWidth <= 767" class="container">
      <div class="alert alert-warning">
        {{ $t("buildingBlocks.alert") }}
      </div>
    </div>
  </main>
</template>

<script>
import game from '@/api/v1/game';
import topContent from '@/api/v1/buldingBlocks';
import Hero from '@/components/Hero';
import Article from '@/components/Article';
import Figures from '@/components/Figures';
import Support from '@/components/Support/Index';
import GameTable from '@/views/Game/BuldingBlocks/Tables/Index';
import GameHeading from '@/views/Game/BuldingBlocks/Heading';
import GameBoard from '@/views/Game/BuldingBlocks/Board/Index';

export default {
  data() {
    return {
      bgImg: 'Banner2-Experiment-',
      subtitle: this.$t('nav.experiment'),
      blocks: [],
      isExpanded: true,
      article: {},
      windowWidth: null,
    };
  },
  components: {
    'section-hero': Hero,
    'section-article': Article,
    'section-figures': Figures,
    'section-support': Support,
    GameTable,
    GameHeading,
    GameBoard,
  },
  computed: {
    isEditable() { return this.$route.name === 'edit_building_blocks'; },
  },
  methods: {
    getBuldingBlocks() {
      const succ = (response) => {
        this.blocks = response.data.building_blocks.reduce((obj, item) => {
          (obj[item.block_type] = obj[item.block_type] || []).push(item); //eslint-disable-line
          return obj;
        }, {});
      };
      game.getBlocks(succ);
    },
    getWindowWidth() {
      this.windowWidth = document.documentElement.clientWidth;
    },
    getContent() {
      const succ = (response) => {
        this.article = response.data.choose_building_blocks;
      };
      topContent.index(succ);
    },
  },
  created() {
    this.getContent();
    this.getWindowWidth();
    this.getBuldingBlocks();
  },
  mounted() {
    window.addEventListener('resize', this.getWindowWidth);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.getWindowWidth);
  },
};
</script>

<style lang="scss" scoped>
@import "./src/styles/helpers/_variables.scss";

.slide-enter-active {
  transition: all .3s ease;
}
.slide-leave-active {
  transition: all .3s ease;
}
.slide-enter, .slide-leave-to {
  transform: translateY(-200px);
  opacity: 0;
}
.section--building-blocks {
  background-color: $color--gray-6;
  padding: 120px 0 100px;
}
.info {
  &__box {
    background-color: $color--white-1;
    padding: 30px 100px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    position: relative;
  }
  &__arrow {
    color: $color--gray-6;
    position: absolute;
    bottom: 0;
    right: 0;
    width: 42px;
    bottom: 15px;
    right: 35px;
    cursor: pointer;
    transition: transform ease 0.2s;
    &--rotate {
      transform: rotate(180deg);
    }
  }
}
  .report {
    display: block;
    width: 50%;
    margin: 0 auto;
    border-radius: 23.5px;
  }
</style>



// WEBPACK FOOTER //
// src/views/Game/BuldingBlocks/Index.vue